<ng-template #modalSequenceAC let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      <i class="fa fa-send"></i>
      Ativação do Active Campaign
    </h4>
    <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" aria-label="Fechar" (click)="modalRef.dismiss()">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="modal-body">
    <div class="notice">
      <i class="fa fa-info-circle"></i>
      <span>Por favor, ative este serviço nas configurações da sua campanha. Feito isto, basta recarregar a página e tudo estará pronto!</span>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="sf-btn sf-btn--ghost push" (click)="modalRef.dismiss()">
      Fechar
    </button>
    <button type="button" class="sf-btn sf-btn--primary" (click)="reload()">
      <i class="fa fa-refresh"></i> Já ativei - Recarregar página
    </button>
  </div>
</ng-template>
